export default {
  name: 'patient-social-name-info-icon',
  props: {
    dataCy: {
      type: String,
      default: 'patient-social-name-info'
    },
    tooltipKey: {
      type: String,
      default: 'social_name'
    }
  },
  computed: {
    label () {
      return this.$t(this.tooltipKey)
    },
    ariaLabel () {
      return this.$t('social_name_info_aria')
    },
    tooltipOptions () {
      return {
        content: this.label,
        placement: 'right',
        trigger: 'hover click focus',
        delay: { show: 100, hide: 100 },
        classes: ['patient-social-name-info-tooltip']
      }
    }
  }
}
